import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { AppConfig } from '../../../app.config';

@Injectable()
export class DeclarationsJustifsService {
    private urlGetJustifs: string = '';
    private urlUpdloadFiles: string = '';
    private urlDeleteJustif: string = '';
    private urlDownloadJustif: string = '';

    constructor(private http: HttpClient, private _appConfig: AppConfig) {
        this.urlGetJustifs = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetListeJustificatifs?idDett=';
        this.urlUpdloadFiles = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/UploadJustificatif?idDett=';
        this.urlDeleteJustif = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/DeleteJustificatif?idDett=';
        this.urlDownloadJustif = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/DownloadJustificatif?idDett=';
    }

    getJustifs(declaId): Observable<any> {
        return this.http.get(this.urlGetJustifs + declaId)
            .catch(this.handleError);
    }

    updloadFiles(declaId, files): Observable<any> {
        const url = this.urlUpdloadFiles + declaId;

        const fileList: FileList = files;
        const formData: any = new FormData();
        if (files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                const file = fileList[i];
                formData.append('files', file);
            }
        }
        return this.http.post(url, formData)
            .catch(this.handleError);
    }

    deleteFile(declaId, storageId) {
        return this.http.get(this.urlDeleteJustif + declaId + '&storageId=' + storageId)
            .catch(this.handleError);
    }

    downloadFile(declaId, storageId) {
        return this.http.get(this.urlDownloadJustif + declaId + '&storageId=' + storageId, { responseType: 'blob' })
            .catch(this.handleError);
    }

    private handleError(err: HttpErrorResponse) {
        console.log(err);
        let errMsg: string;
        if (err && (err.error instanceof Error)) {
            errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
        } else if (err && err.error) {
            errMsg = (err.error.message ? err.error.message : err.error.toString());
        } else if (typeof err == 'string') {
            errMsg = err;
        }

        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/in/mes-declarations/services/declarations-justifs.service.ts